export const ACTIVATION_TOKEN_ERROR_ROUTES = {
  used: { to: "/auth/login", reason: "already_used" },
  expired: { to: "/auth/request-reactivation", reason: "expired" },
};

export const ACTIVATION_TOKEN_FALLBACK_ROUTE = {
  to: "/auth/request-reactivation",
  reason: "invalid",
};

export const PIN_RESET_TOKEN_ERROR_ROUTES = {
  used: { to: "/auth/login", reason: "pin_reset_already_used" },
  expired: { to: "/auth/forgot-pin", reason: "pin_reset_expired" },
};

export const PIN_RESET_TOKEN_FALLBACK_ROUTE = {
  to: "/auth/forgot-pin",
  reason: "pin_reset_invalid",
};
